import React from 'react';

export const SwitchContainer = ({ fallback = null, onlyFirstMatch = false, children }) => {
  const matchedChildren = React.Children.toArray(children).filter((child) => child.props.when);
  const childrenToShow = onlyFirstMatch ? matchedChildren[0] : matchedChildren;

  return <>{matchedChildren.length ? childrenToShow : fallback}</>;
};

export const Case = ({ when, children }) => (when ? children : null);
